import { Component, forwardRef, HostBinding, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Compliment } from '@fmnts/api';
import { FmntsComplimentModule } from '@fmnts/components/compliment';
import {
  AbstractDeclarativeInputFieldComponent,
  FormSelectField,
} from '@fmnts/declarative-forms';
import { SharedDeclarativeCampaignFormsModule } from '../../shared-declarative-next-forms.module';

type FieldValue = readonly string[];

/**
 * Form field component that shows an input for selecting
 * compliments.
 */
@Component({
  selector: 'next-compliments-select-field',
  templateUrl: './compliments-select-field.component.html',
  standalone: true,
  imports: [SharedDeclarativeCampaignFormsModule, FmntsComplimentModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ComplimentsSelectFieldComponent),
      multi: true,
    },
  ],
})
export class ComplimentsSelectFieldComponent
  extends AbstractDeclarativeInputFieldComponent<FormSelectField, FieldValue>
  implements OnInit
{
  @HostBinding('class') componentClass = 'form-field form-field__compliments';

  public compliments: Compliment[] = [];

  get value(): FieldValue {
    return this._value;
  }
  set value(newValue: FieldValue) {
    this._value = newValue;
    this._onChange(this._value);
    this._onTouched();
  }
  private _value: FieldValue = [];

  ngOnInit() {
    this.compliments = this.field.widgetOptions.items.map(
      (c) => new Compliment(c as Compliment),
    );
  }

  override writeValue(obj: any): void {
    // Ensure that selected is an array
    this._value = obj ?? [];
  }
}
